<template>
    <div>
      <div class="container">
        <el-dialog
            title="Binning"
            :visible.sync="bin_show"
        >
          <p>By default Chimera uses powerful auto-binning. That said, you may choose to turn binning off.
          The most common example would be where you only want to see the top values.
          If no binning is used then autobinning will happen.</p>
          <p>What is binning? Binning is where multiple values are put into one visual element in a chart.
          For instance, by default Chimera creates an "Other" bar in bar charts if there would ordinarily
          by more bars than would fit. Multiple would-be bars are accounted for in the "Other" bar.</p>
          <p>Binning of {{distribution_word}}</p>
          <el-select filterable style="padding-left:10px;" v-model="tentative_bin_field" placeholder="Select">
            <el-option
                :key="1"
                label="Auto"
                value="auto"
            ></el-option>
            <el-option
                :key="2"
                label="None"
                value="none"
            ></el-option>
          </el-select>
          <div v-if="chart_config.color_by_field">
            <p>Binning of {{color_text}}</p>
            <el-select filterable style="padding-left:10px;" v-model="tentative_bin_color" placeholder="Select">
              <el-option
                  :key="1"
                  label="Auto"
                  value="auto"
              ></el-option>
              <el-option
                  :key="2"
                  label="None"
                  value="none"
              ></el-option>
            </el-select>
          </div>
          <el-button @click="binSet">Use</el-button>
        </el-dialog>
        <el-dialog
            title="Set Details Field"
            :visible.sync="detail_show"
        >
          <p>The details fields will be shown in the spreadsheet view, but are
          not used in the chart. Some default values will always be displayed, as
          will all the fields used in the chart.</p>
          <el-transfer
              v-model="detail_fields_structured" :data="metadata"
              :props="{
                key: 'display_name',
                label: 'display_name',
              }"
          />
          <el-input v-model="temp_config.detail_fields"></el-input>
          <el-button @click="save_details_field">Use</el-button>
        </el-dialog>
      <el-dialog
                title="Create New Summary Table (EXPERT FEATURE!)"
                :visible.sync="show_new_summary_table">
            <div>
                Summary Table Name
                <el-input v-model="new_summary.name"></el-input>

            </div>
            <div>
                Multi-value field
                <el-select filterable style="padding-left:10px;" v-model="new_summary.multi_value_field" placeholder="Select">
                    <el-option
                            v-for="field in base_metadata.multi"
                            :key="field.id"
                            :label="field.display_name"
                            :value="field.display_name">
                    </el-option>
                </el-select>
            </div>
            <div>
                Category field
                <el-select filterable style="padding-left:10px;" v-model="new_summary.category_field" placeholder="Select">
                    <el-option
                            v-for="field in base_metadata.categories"
                            :key="field.id"
                            :label="field.display_name"
                            :value="field.display_name">
                    </el-option>
                </el-select>
                <p>The <strong>count</strong> field will automatically be created. You may also
                define another metric.</p>
                Metric
                <el-select filterable style="padding-left:10px;" v-model="new_summary.metric1" placeholder="Select">
                    <el-option
                            v-for="field in base_metadata.categories"
                            :key="field.id"
                            :label="field.display_name"
                            :value="field.display_name">
                    </el-option>
                </el-select>
            </div>

            <el-button v-on:click="summaryCancel">Cancel</el-button>
            <el-button v-on:click="saveSummaryDefinitionAndFlatten">Save and Generate Summary Table</el-button>
        </el-dialog>
        <el-dialog
                title="Search URL"
                :visible.sync="url_show_search">

            <el-input placeholder="Enter full URL (like https://davidhobbsconsulting.com)" v-model="url_to_search"></el-input>
            <el-button v-on:click="searchUrl" style="margin-top:10px;">Search</el-button>
            <div style="margin-top:20px;">
                <div v-if="this.url_search_results && this.url_search_results.error">
                  <p style="color:red">{{url_search_results.error}}</p>
                </div>
                <div v-else-if="this.url_search_results && this.url_search_results.times_encountered > 0">
                  <p><strong>This URL is in the database.</strong></p> Details:
                    <ul>
                        <li v-if="url_search_results.first_encountered">First encountered: {{url_search_results.first_encountered}}</li>
                        <li v-if="url_search_results.last_encountered">Last encountered: {{url_search_results.last_encountered}}</li>
                        <li>Times encountered: {{url_search_results.times_encountered}}</li>
                    </ul>
                   <el-button v-on:click="go_details(extent_id,url_search_results.processed_asset.id)">See all information on this URL</el-button>
                </div>
                <div v-else-if="this.url_search_results && this.url_search_results.redirect_type">
                  <p><strong>
                    This URL was crawled, but it was directed to {{url_search_results.redirect_to}}
                    with a {{url_search_results.redirect_type}} redirect.
                    <el-button @click="redo">Redo search on the URL Content Chimera was redirected to.</el-button>
                  </strong></p>
                </div>
                <div v-else-if="this.url_search_results">
                    <p><strong>This URL was not successfully crawled or imported.</strong></p>
                </div>
            </div>
        </el-dialog>
        <el-dialog
                title="Advanced Filter"
                :visible.sync="filter_show"
                @close="filterEditClose"
                width="70%"
        >

            <filter-edit
                    :asset_filter_id="chart_config.asset_filter_id"
                    :extent_id="extent_id"
                    @filterSaved="handleFilterSaved"
                    @filterReset="handleFilterReset"
                    @filterLoaded="handleFilterLoaded"
                    ref="assetFilterEdit"
            ></filter-edit>
        </el-dialog>
        <el-dialog
                :title="color_by_text"
                :visible.sync="color_show">

            <div v-if="chart_config.chart_type=='pervasiveness' || chart_config.chart_type=='table_custom'">
                <el-input placeholder="Comma-separated (no spaces) field names for columns" v-model="tentative_color_by_field"></el-input>
            </div>
            <div v-else>
              <div style="margin-bottom:20px;">
                Field to color by
                <el-select filterable style="padding-left:10px;" v-model="tentative_color_by_field" placeholder="Select">
                    <el-option
                            v-for="field in metadata_filtered_by_priority"
                            :key="field.id"
                            :label="field.display_name"
                            :value="field.display_name">
                    </el-option>
                </el-select>
              </div>
            </div>
            <div>
              <div>
                Max {{color_by_text}}{{color_by_text.endsWith('s')?'':'s'}}
                <el-input v-model="tentative_max_colors"></el-input>
                <el-button v-on:click="colorCancel">Reset for no {{color_by_text}}</el-button>
                <el-button v-on:click="colorSet">Set</el-button>
              </div>
            </div>
        </el-dialog>
        <el-dialog
            :title="color_by_text"
            :visible.sync="color_scheme_show">
          <div style="margin-bottom:20px;">
            Color Scheme
            <el-select filterable style="padding-left:10px;" v-model="tentative_color_scheme" placeholder="Select">
              <el-option
                  v-for="field in color_schemes"
                  :key="field.id"
                  :label="field.name"
                  :value="field.id">
              </el-option>
            </el-select>
          </div>
          <div v-if="tentative_color_scheme && color_schemes.length>0" style="margin-bottom:20px;">
            <table>
              <tr>
                <th style="padding: 15px;">Field Value</th>
                <th style="padding: 15px;">Color</th>
              </tr>
              <tr v-for="color in color_schemes.find((scheme) => scheme.id === tentative_color_scheme).colors">
                  <td v-if="color.field_value" style="text-align:center;">{{color.field_value }} → </td>
                  <td v-else style="color:gray;text-align:center;">open</td>
                  <td
                        :style="
                                  'padding: 5px; margin: 10px; background-color:' +
                                   color.color +
                                   '; color:' +
                                   tinycolor.mostReadable(color.color,['#000', '#fff', '#F5DF8F','#2178B4']).toHexString()
                                "
                  >{{color.color}}</td>
              </tr>
            </table>
          </div>
          <div>
            <el-button v-on:click="colorSchemeCancel">Reset to default color scheme.</el-button>
            <el-button v-on:click="colorSchemeSet">Set</el-button>
          </div>
        </el-dialog>
        <el-dialog
                :title="group_by_text"
                :visible.sync="group_show">

          <div>
            {{group_by_text}} By:
            <el-select filterable style="padding-left:10px;" v-model="tentative_group_by_field" placeholder="Select">
                <el-option
                        v-for="field in metadata_filtered_by_priority"
                        :key="field.id"
                        :label="field.display_name"
                        :value="field.display_name">
                </el-option>
            </el-select>
          </div>
          <div style="margin-bottom:20px;">
            Max {{group_by_text}}s
            <el-input v-model="tentative_max_groups"></el-input>
          </div>
          <div>
            <el-button v-on:click="groupCancel">Reset to for no {{group_by_text}}</el-button>
            <el-button v-on:click="groupSet">Set</el-button>
          </div>
        </el-dialog>
        <el-dialog
                :title="'Maximum ' + bars_text"
                :visible.sync="max_bars_show">

            <el-input :placeholder="'Enter the maximum ' + bars_text" v-model="tentative_max_bars"></el-input>

            <el-button v-on:click="maxBarsCancel">Reset to default</el-button>
            <el-button v-on:click="maxBarsSet">Set</el-button>
        </el-dialog>
        <!--- start SORT BY --->
        <el-dialog
            :title="'Sorting ' + distribution_word"
            :visible.sync="sort_show">

          <p>By default the sort is by the size field. Ordinarily it only makes sense to sort
          on something that is specifically being charted.</p>

          <p>Sorting Field</p>
          <el-select filterable style="padding-left:10px;" v-model="tentative_sort_by_field" placeholder="Select">
            <el-option
                v-for="field in metadata_filtered_by_priority"
                :key="field.id"
                :label="field.display_name"
                :value="field.display_name">
            </el-option>
          </el-select>
          <p>Aggregation Function (optional)</p>
          <el-select filterable style="padding-left:10px;" v-model="tentative_sort_by_aggregation" placeholder="Select">
            <el-option
                v-for="item in agg_functions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

          <p>Sorting Order (optional)</p>
          <el-select filterable style="padding-left:10px;" v-model="tentative_sort_by_asc_as_boolean" placeholder="Select">
            <el-option
                :key="1"
                label="Ascending"
                :value="true"
            >
            </el-option>
            <el-option
                :key="2"
                label="Descending"
                :value="false"
            >
            </el-option>
          </el-select>

          <div>
            <el-button v-on:click="sortCancel">Reset to default (sort by size field)</el-button>
            <el-button v-on:click="sortSet">Set</el-button>
          </div>
        </el-dialog>
        <!--- end --->
        <el-dialog
                :title="button_text.size"
                :visible.sync="size_show">

            <p> Current {{button_text.size}}: {{sizing_text}} (default of sum(count) if blank).</p>
          <p>Aggregation Function</p>
          <el-select filterable style="padding-left:10px;" v-model="chart_config.agg_function" placeholder="Select">
                <el-option
                        v-for="item in agg_functions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>

            <p>Field</p>
            <el-select filterable style="padding-left:10px;" v-model="chart_config.size_field" placeholder="Select">
                <el-option
                        v-for="field in metadata_filtered_by_priority"
                        :key="field.id"
                        :label="field.display_name"
                        :value="field.display_name">
                </el-option>
            </el-select>

            <el-button v-on:click="sizeCancel">Reset to default (count field)</el-button>
            <el-button v-on:click="sizeSet">Set</el-button>
        </el-dialog>
        <el-dialog
                title="Size of bars (2)"
                :visible.sync="size_show2">

            <p> Current size: {{sizing_text2}}</p>
            <el-select filterable style="padding-left:10px;" v-model="chart_config.agg_function2" placeholder="Select">
                <el-option
                        v-for="item in agg_functions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>

            <p>Enter the field that determines the size of a bar (for bar chart) or region (for treemap)</p>
            <el-select filterable style="padding-left:10px;" v-model="chart_config.size_field2" placeholder="Select">
                <el-option
                        v-for="field in metadata_filtered_by_priority"
                        :key="field.id"
                        :label="field.display_name"
                        :value="field.display_name">
                </el-option>
            </el-select>

            <el-button v-on:click="sizeCancel2">Reset to default</el-button>
            <el-button v-on:click="sizeSet2">Set</el-button>
        </el-dialog>

        <el-dialog
                title="Size of text"
                :visible.sync="text_size_show">
            <p>This feature only works for treemaps.</p>
            <div class="block">
                <el-slider v-model="text_size"></el-slider>
            </div>
        </el-dialog>

        <el-dialog
                title="Save As"
                :visible.sync="save_chart_show">

            Name*<el-input placeholder="Name of chart, which will appear in the chart pulldown" v-model="new_chart_name"></el-input>
            Description<el-input placeholder="Optional description of chart, which will appear under the title when viewed on the assets page" v-model="new_chart_description"></el-input>

            <el-button style="margin-top:10px;" v-on:click="save_chart(true)">Save</el-button>


        </el-dialog>

        <div class="row">
            <div class="col-md-12 ">
                <ExtentList @checkChange="handleCheckChangeParent" @startProcessing="startProcessing" />
            </div>
        </div>

        <div v-if="error_msg" class="row" style="padding-bottom: 15px;">
            <div class="col-md-12">
                <el-alert
                        :title="error_msg"
                        :type="error_type">
                </el-alert>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 ">
                <div v-if="have_data !== 'no' " class="panel panel-default">
                    <div class="panel-heading">
                        Charts

                            <el-select filterable style="padding-left:10px;" v-model="selected_saved_chart" placeholder="Select">
                                <el-option
                                        v-for="chart in charts"
                                        :key="chart.id"
                                        :label="chart.display_name"
                                        :value="chart.id">
                                    <span>{{ chart.display_name}}</span>
                                    <el-tag type="info" size="mini" style="margin-left:20px;float:right;margin-top:7px;">{{ chart.nice_required_job_name }}</el-tag>
                                </el-option>
                            </el-select>
                      <span id="chart_list">
                      </span>
                        <el-button @click="toggle_chart_advanced" icon="el-icon-setting"></el-button>
                        <span v-if="show_over_time && show_bleeding_edge && snapshots && (chart_config.chart_type !== 'timeseries')" style="background-color: gray">
                          <span v-if="showSnapshotFeatures">
                            <el-button type="info" @click="a" icon="el-icon-date"></el-button>
                            <span v-if="snapshotEarliest">
                              <el-button disabled icon="el-icon-back"></el-button>
                            </span>
                            <span v-else>
                              <el-button @click="moveVersionBackward" icon="el-icon-back"></el-button>
                            </span>
                            <span v-if="snapshotLatest">
                              <el-button disabled icon="el-icon-right"></el-button>
                            </span>
                            <span v-else>
                               <el-button @click="moveVersionForward" icon="el-icon-right"></el-button>
                            </span>
                            <el-button v-if="chart_config.chart_type === 'bar' || chart_config.chart_type === 'pie'" @click="convertToTimeSeries">Convert to time series</el-button>
                          </span>
                          <span v-else>
                            <el-button @click="a" icon="el-icon-date"></el-button>
                          </span>
                        </span>
                        <filters
                            :metadata="metadata"
                            :metadata_extended="metadata_extended"
                            :extent_id="extent_id"
                            :filter_id="chart_config.asset_filter_id"
                            @updateAllFilterTests="updateAllFilterTests"
                            :temp_filter_tests_to_add="temp_filter_tests_to_add"
                            :reset="reset_filter"
                        >
                        </filters>
                      <div style="float:right">
                        <el-button @click="toggle_click('chart')" size="mini" icon="el-icon-s-data" :type="modes_enabled.chart ? 'success' : 'default'"></el-button>
                        <el-button @click="toggle_click('table')" size="mini" icon="el-icon-s-grid" :type="modes_enabled.table ? 'success' : 'default'"></el-button>
                        <el-button v-if="show_table && can_show_import && show_import" @click="toggle_click('import')" size="mini" icon="el-icon-bottom-right" :type="modes_enabled.import ? 'success' : 'default'"></el-button>
                      </div>

                      <div v-if="snapshotDate && chart_config.chart_type!=='timeseries'" style="margin-top:10px;">
                        <span style="width:100%;padding: 8px;display:inline-block;text-align:center;background-color:#909399;color:white;font-size:smaller;">
                          <span style="color:palegoldenrod">Snapshot:</span> {{snapshotDescription}}
                          <strong>{{snapshotDate}}</strong>
                        </span>
                      </div>

                      <div v-if="!chart_changed_from_saved && modes_enabled.chart" style="margin-top:20px">{{chart_config.description}}</div>

                    </div>
                    <div v-if="show_chart_advanced">
                        <div class="panel-heading">
                            <div style="margin-bottom:10px;">
                              Simplified
                              <el-switch
                                      v-model="show_chart_super_advanced"
                                      active-color="#ff4949"
                                      inactive-color="#13ce66">
                              </el-switch>
                              Advanced
                            </div>
                            <div style="margin-bottom:20px;">

                                <span v-show="show_buttons.group" style="margin-right:10px;">
                                    <span
                                            :style=" !show_chart_super_advanced && show_buttons.group === 2 ? 'padding-bottom:15px;border-bottom: 2px #13ce66 solid;' : '' "
                                    >
                                      <el-button @click="groupOverlay()">{{group_by_text}}</el-button>
                                      <span v-if="chart_config.group_by_field" style="margin-right:20px;">= {{chart_config.group_by_field}}</span>
                                    </span>
                                </span>
                              <span
                                      v-show="show_buttons.field_name"
                                      :style=" !show_chart_super_advanced ? 'padding-bottom:15px;border-bottom: 2px #13ce66 solid;' : '' ">

                                {{distribution_of_text}}
                                        <el-select filterable style="padding-left:10px;" v-model="chart_config.field_name" placeholder="Select">
                                            <el-option
                                                    v-for="field in metadata_filtered_by_priority"
                                                    :key="field.id"
                                                    :label="field.display_name"
                                                    :value="field.display_name">
                                            </el-option>
                                        </el-select>
                              </span>
                              <span style="margin-left: 15px;" v-show="show_buttons.targets">
                                  Based on Target:
                                  <el-select filterable style="padding-left:10px;" v-model="chart_config.target_id" placeholder="Select">
                                    <el-option
                                        v-for="target in targets"
                                        :key="target.id"
                                        :label="target.name"
                                        :value="target.id"
                                    ></el-option>
                                  </el-select>
                                </span>
                              <span v-show="show_buttons.color">
                                    <el-button @click="switch_color_and_primary()">⟺</el-button>
                                  <span :style=" !show_chart_super_advanced && show_buttons.color === 2 ? 'padding-bottom:15px;border-bottom: 2px #13ce66 solid;' : '' ">
                                    <el-button style="margin-left:0px!important" @click="colorOverlay()">{{color_by_text}}</el-button>
                                    <span v-if="chart_config.color_by_field">= {{chart_config.color_by_field}}</span>
                                  </span>
                                </span>
                                <el-button v-show="
                                  chart_config.chart_type !== 'table_custom' &&
                                  (
                                    chart_config.color_by_field ||
                                    chart_config.chart_type==='pie' ||
                                    chart_config.chart_type==='stellar' ||
                                    chart_config.chart_type==='bump'
                                    )" style="margin-left:0px!important;margin-right:5px;" @click="colorSchemeOverlay()">
                                  Color Scheme
                                </el-button>{{color_scheme_value}}
                                <el-button v-show="modes_enabled.table" @click="initiate_detail_dialog" type="primary">Extra Columns</el-button>
                                <el-button v-show="modes_enabled.table" @click="show_search_url()">Search URL</el-button>

                            </div>
                            <div style="margin-bottom:20px;">
                                <span v-show="show_buttons.filter && show_chart_super_advanced">
                                    <el-button @click="filterOverlay()">Manage Shared Filters</el-button>
                                    <span>{{filter_text}}</span>
                                </span>

                                <span v-show="show_buttons.bars && !modes_enabled.table">
                                    <el-button @click="maxBarsOverlay()">{{bars_text}}</el-button>
                                    <span>{{chart_config.max_bars}}</span>
                                </span>
                                <span v-show="show_buttons.size && !modes_enabled.table">
                                    <span
                                            :style=" !show_chart_super_advanced && show_buttons.size === 2 ? 'padding-bottom:15px;border-bottom: 2px #13ce66 solid;' : '' "
                                    >
                                      <el-button @click="sizeOverlay()">{{button_text.size}}</el-button>
                                      <span>{{sizing_text}}</span>
                                    </span>
                                </span>
                                <span v-show="show_buttons.size2 && !modes_enabled.table">
                                    <span
                                            :style=" !show_chart_super_advanced && show_buttons.size === 2 ? 'padding-bottom:15px;border-bottom: 2px #13ce66 solid;' : '' ">
                                        <el-button @click="sizeOverlay2()">{{button_text.size2}}</el-button>
                                        <span>{{sizing_text2}}</span>
                                    </span>
                                </span>
                                <span v-show="!modes_enabled.table">
                                    <el-button v-if="show_buttons.sort" @click="sortOverlay()">Sort</el-button>
                                    <el-button v-if="show_buttons.binning" @click="binOverlay()">Binning</el-button>
                                    <span v-if="show_buttons.annotations">
                                         Show Annotations <el-checkbox v-model="tentative_show_annotations_as_boolean"></el-checkbox>
                                    </span>
                                </span>
                                <el-button v-show="show_buttons.size_text" @click="textSizeOverlay()">Text size</el-button>
                            </div>
                            <div v-if="show_buttons.dates" style="margin-bottom:20px;">
                                <span
                                        :style=" !show_chart_super_advanced && show_buttons.dates === 2 ? 'padding-bottom:15px;border-bottom: 2px #13ce66 solid;' : '' "
                                >
                                                                    Date Range:
                                <el-select filterable style="padding-left:10px;" v-model="chart_config.timeseries_duration" placeholder="Select">
                                  <el-option
                                          v-for="duration in durations"
                                          :key="duration.key"
                                          :label="duration.label"
                                          :value="duration.key">
                                  </el-option>
                                </el-select>
                                <span v-if="chart_config.timeseries_duration==='custom'">
                                  From
                                  <el-date-picker
                                          v-model="chart_config.timeseries_start"
                                          value-format="yyyy-MM-dd"
                                          type="date"
                                          placeholder="Select start date">
                                  </el-date-picker>
                                  To
                                  <el-date-picker
                                          v-model="chart_config.timeseries_end"
                                          value-format="yyyy-MM-dd"
                                          type="date"
                                          placeholder="Select end date">
                                  </el-date-picker>
                                </span>
                                <span style="margin-left:10px;" v-show="show_over_time">
                                    Date Field:
                                    <el-select filterable style="padding-left:10px;" v-model="chart_config.date_field" placeholder="Select">
                                      <el-option
                                              v-for="field in metadata_filtered_by_priority"
                                              :key="field.id"
                                              :label="field.display_name"
                                              :value="field.display_name">
                                      </el-option>
                                    </el-select>
                                  </span>
                                </span>
                            </div>
                            <div style="margin-bottom:20px;">
                                <el-button @click="save_chart(false)">Save</el-button>
                                <el-button @click="show_save_chart_dialog()">Save As</el-button>
                                <el-button v-show="show_chart_super_advanced" @click="reset()">Reset Chart</el-button>
                                <el-button v-show="show_chart_super_advanced" @click="redraw()">Redraw</el-button>
                                <el-button v-show="show_chart_super_advanced" @click="redraw(true)">Large Query Redraw</el-button>
                                <el-button v-show="show_buttons.switch_orientation" @click="switch_orientation()">Switch orientation</el-button>
                                <el-select filterable style="padding-left:10px;" v-model="chart_config.chart_type" placeholder="Select">
                                    <el-option
                                            v-for="type in chartTypes"
                                            :key="type.key"
                                            :label="type.label"
                                            :value="type.key">
                                    </el-option>
                                </el-select>
                                <el-button v-show="show_chart_super_advanced" @click="full_screen()">Full Screen</el-button>
                                <el-button v-show="show_chart_super_advanced" @click="full_width()">Full Width</el-button>

                            </div>
                            <div v-show="show_chart_super_advanced">
                                <el-button @click="download_csv()">Download Summary CSV</el-button>
                                <el-button @click="to_outline()">Outline</el-button>
                                <el-button v-show="show_bleeding_edge" @click="profile_chart()">Profile Performance</el-button>
                            </div>
                            <div  v-show="show_chart_super_advanced"  style="margin-top:10px;">
                              <el-button @click="go_table_definition" style="margin-right:10px;">Show Data Table Info</el-button>

                              <el-checkbox style="margin-top:10px;" v-model="use_default_data_table">Use Default Data Table</el-checkbox>

                                <span v-show="!use_default_data_table">
                                    <span v-show="summary_tables">
                                        <el-select  filterable style="padding-left:10px;" v-model="chart_config.summary_table_id" placeholder="Select">
                                            <el-option
                                                    v-for="table in summary_tables"
                                                    :key="table.id"
                                                    :label="table.long_name"
                                                    :value="table.id">
                                            </el-option>
                                        </el-select>
                                        <el-button @click="startProcessingSummary">Refresh Summary Table</el-button>
                                    </span>
                                    <el-button @click="showNewSummaryTable">New Summary Table</el-button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
        <!--- START -->
        <div :class="container_class" v-if="have_data!=='no' && modes_enabled.chart">
          <div class="row">
            <div class="col-md-12 ">
              <div class="panel-body" id="primary-chart" style="background-color:white;margin-bottom:20px;">
                <SingleFieldBarChart :version="redraw_count"
                                     :height="chart_height"
                                     :width="chart_width"
                                     @chartError="chartError"
                                     @dataLoaded="dataLoaded"
                                     @colorsLoaded="colorsLoaded($event)"
                                     @chartMetaLoaded="chartMetaLoaded($event)"
                                     @set_drilldown="set_drilldown"
                                     :text_size="text_size"
                                     :chart_config="chart_config"
                                     :extent_id="extent_id"
                                     :filter_name="filter_name"
                                     :metadata="metadata"
                                     :snapshotId="snapshotId"
                                     :additional_filters="all_filter_tests"
                                     :forced="forced"
                />
              </div>
            </div>
          </div>
        </div>
        <!--- END -->
        <div class="container">
          <div class="row">
            <div class="col-md-12 ">
        <div id="import">
          <div v-if="extent_state==='archived'" style="background-color:#FFE98A;padding:10px;margin-bottom:20px;">
              You cannot add more data to an archived extent.
          </div>
          <div v-else>
              <div v-if="have_data==='no' || !show_table || (can_show_import && modes_enabled.import)" class="row">
                  <div v-if="can_crawl" class="col-md-4 ">
                      <div class="panel panel-default">
                          <div class="panel-heading">Add Assets by crawling</div>

                          <div class="panel-body">
                              <crawl :button_type="crawl_button_type" :selected_extent="extent_id"/>
                          </div>
                      </div>
                      <div id="import_box" class="panel panel-default">
                          <div class="panel-heading">Add Assets from Another Source</div>

                              <div class="panel-body">
                              <data-import-input :selected_extent="extent_id"/>
                              </div>
                      </div>
                  </div>
                  <div v-if="have_data !== 'no'" class="col-md-4 ">
                      <div class="panel panel-default">
                          <div class="panel-heading">Add Metadata from Another Source</div>

                          <div class="panel-body">
                              <merge-metadata :selected_extent="extent_id" />
                          </div>
                      </div>
                      <div class="panel panel-default">
                          <div class="panel-heading">Text Analysis</div>

                          <div class="panel-body">
                              <rot-analysis-input :selected_extent="extent_id"/>
                          </div>
                      </div>
                  </div>
                  <div v-if="have_data !== 'no'" class="col-md-4 ">
                      <scrape :selected_extent="extent_id" />
                  </div>
              </div>
          </div>
        </div>

        <tour-manager :tour="tour"></tour-manager>
        </div>
          </div>
      </div>
      <asset-table-view v-if="modes_enabled.table && show_table"
                        :extent_id="extent_id"
                        :colors="colors"
                        :colored_prop="chart_config.color_by_field"
                        :fields="fields"
                        :asset_filter_id="chart_config.asset_filter_id"
                        :redraw_count="redraw_count"
                        :flattened_table_id="chart_config.summary_table_id"
                        :additional_filters="all_filter_tests"
      >

      </asset-table-view>

    </div>

</template>

<script>
    const tinycolor = require('tinycolor2');
    import * as screenfull from 'screenfull';
    export default {
        mounted() {
            if (chimera.permissions.includes('BLEEDING_EDGE')) this.show_bleeding_edge = true
            if (!this.show_bleeding_edge) {
              this.chartTypes = this.chartTypes.filter(item => {
                return ! item.bleeding
              })
            }
            if (chimera.features.includes('list_view')) this.show_table = true
            if (chimera.features.includes('over_time')) this.show_over_time = true
            if (chimera.permissions.includes('CRAWL')&&chimera.permissions.includes('IMPORT')) this.show_import = true

        },
        data() {
            return {
              user: null,
              targets: null,
              tinycolor: tinycolor,
              modes_enabled: {
                chart: true,
                table: false,
                import: false,
              },
              all_filter_tests: [],
              temp_filter_tests_to_add: [],
              reset_filter: false,
              forced: false,
              durations: [
                  {
                    key: null,
                    label: "All"
                  },
                  {
                    key: 'custom',
                    label: 'Custom'
                  },
                  {
                    key: 'last_year',
                    label: 'Last Year'
                  },
                  {
                    key: 'last_month',
                    label: 'Last Month'
                  },
                  {
                    key: 'last_12_months',
                    label: 'Last Twelve Months'
                  },
                  {
                    key: 'last_30_days',
                    label: 'Last Thirty Days'
                  },
                ],
                extent_id: null,
                extent_type: "",
                extent_state: "",
                extent_default_chart_id: null,
                sample: null,
                show_table: false,
                show_over_time: false,
                show_import: false,
                container_class: 'container',

                snapshots: null,
                snapshotIndex: null,
                snapshotId: null,
                showSnapshotFeatures: false,
                snapshotDate: null,
                snapshotDescription: null,
                snapshotEarliest: false,
                snapshotLatest: true,
                timeTraveling: false,

                colors: [],
                chartMeta: [],

                detail_show: false,

                // Should probably refactor toward using this throughout
                temp_config: {
                    detail_fields: '',
                },
                detail_fields_structured: [],

                chart_config: {
                    // CHANGED from chartType
                    chart_type: "bar",
                    // CHANGED from aggregated_field
                    field_name: "folder1", // default to folder1 since that's usually pretty interesting
                    // The following is NOT yet used, but it is in the ChartConfig
                    sort_by_field: null,
                    // CHANGED from group_field
                    group_by_field: null,
                    // The following is NOT yet used, but it is in the ChartConfig
                    group_by_sort: null,
                    // The following is NOT yet used, but it is in the ChartConfig
                    max_groups: null,
                    max_bars: null,
                    // CHANGED from color_field
                    color_by_field: null,
                    // The following is NOT yet used, but it is in the ChartConfig
                    max_colors: null,
                    agg_function: null,
                    size_field: null,
                    data_type: null,
                    // CHANGED from filter_id
                    asset_filter_id: null,
                    summary_table_id: null,
                    // This is NOT in ChartConfig, but needs to be added
                    size_field2: null,
                    agg_function2: null,
                    detail_fields: '',
                    sort_by_aggregation: null,
                    sort_by_asc: true,
                    bin_field: null,
                    bin_color: null,
                    show_annotations: null,
                    target_id: null,
                    timeseries_start: null,
                    timeseries_end: null,
                    date_field: 'date_of_data',
                },

                last_redraw: null,
                redraw_count: 0,

                url_show_search: false,
                url_to_search: "",
                url_search_results: null,
                url_found_result: false,
                url_no_results: false,

                // ATTRIBUTES FOR CHART DEFINITION UI
                filter_show: false,
                filter_name: null,
                color_show: false,
                color_scheme_show: false,
                max_bars_show: false,
                group_show: false,
                size_show: false,
                size_show2: false,

                chartTypes: [
                    {
                        key: 'bar',
                        label: 'Bar',
                        bleeding: false,
                    },
                    {
                      key: 'horizontalbar',
                      label: 'Horizontal Bar',
                      bleeding: false,
                    },
                    {
                        key: 'treemap',
                        label: 'Treemap',
                        bleeding: false,
                    }, {
                        key: 'tableheatmap',
                        label: 'Heatmap Table',
                      bleeding: false,
                  }, {
                        key: 'scatter',
                        label: 'Scatter',
                        bleeding: false,
                  }, {
                        key: 'sankey',
                        label: 'Sankey',
                        bleeding: false,
                  }, {
                        key: 'pie',
                        label: 'Pie',
                        bleeding: false,
                  }, {
                        key: 'pervasiveness',
                        label: 'Pervasiveness',
                    bleeding: false,
                  }, {
                        key: 'strip_plot',
                        label: 'Strip Plot',
                    bleeding: false,
                  }, {
                        key: 'timeseries',
                        label: 'Time Series',
                    bleeding: false,
                  }, {
                        key: 'big_number',
                        label: 'Big Number',
                        bleeding: false,
                  }, {
                    key: 'sunburst',
                    label: 'Sunburst',
                    bleeding: false,
                  }, {
                    key: 'icicle',
                    label: 'Icicle',
                    bleeding: false,
                  }, {
                    key: 'table_custom',
                    label: 'Custom Table',
                    bleeding: false,
                  }, {
                    key: 'word_cloud',
                    label: 'Word Cloud',
                    bleeding: true,
                  }, {
                    key: 'proportional_area',
                    label: 'Proportional Area',
                    bleeding: true,
                  }, {
                      key: 'stellar',
                      label: 'Stellar',
                      bleeding: true,
                  }, {
                      key: 'sitemap',
                      label: 'Condensed Tree',
                      bleeding: true,
                  }, {
                    key: 'bump',
                    label: 'Bump Chart',
                    bleeding: true,
                  },
                ],
                search_url: "",

                show_chart: false,

                is_full_screen: false,

                text_size: 50, // This is normal size, 50 out of 100
                text_size_show: false,
                have_data: "unknown", // other options: yes and no
                have_spreadsheet_data: "unknown",

                crawl_button_type: "primary",
                error_msg: null,
                error_type: null,

                can_show_import: true,
                want_show_import: false,

                save_chart_show: false,
                chart_owner_radio: 'extent_id',
                charts: null,
                selected_saved_chart: null,
                new_chart_name: "",
                new_chart_description: "",
                show_chart_advanced: false,
                show_chart_super_advanced: false,
                chart_changed_from_saved: false,
                loaded_saved: false,

                // These are values that are entered in dialogs but are not
                // stored to the chart_config until they are saved from that
                // dialog.
                // Items that are directly selected (with no confirm) from the
                // front end do not have a corresponding value here.
                tentative_max_bars: null,
                tentative_group_by_field: null,
                tentative_max_groups: null,
                tentative_color_by_field: null,
                tentative_color_scheme: 1,
                tentative_max_colors: null,
                sort_show: false,
                tentative_sort_by_field: null,
                tentative_sort_by_aggregation: null,
                tentative_sort_by_asc: 1,
                tentative_sort_by_asc_as_boolean: true,
                tentative_bin_field: null,
                tentative_bin_color: null,
                tentative_show_annotations_as_boolean: true,
                bin_show: false,
                color_schemes: [],

                show_bleeding_edge: false,
                profile: false,

                // Need to refactor to using this consistently (rather than separate variables per button)
                button_text: {
                    size: 'Size',
                    size2: null // only scatter chart has a second "size" button
                },

                show_buttons: {
                    field_name: 1,
                    switch_orientation: 0, // Only add back in when it works again
                    group: 1,
                    color: 1,
                    bars: 1,
                    size_text: 0, // bar should not show this
                    size: 1,
                    filter: 1,
                    size2: 0,
                    dates: 0,
                    annotations: 0,
                    binning: 1,
                    sort: 1,
                    targets: 0,
                },

                required_text: {
                    'treemap': 'test'
                },

                // Some buttons/options are not appropriate for certain chart types.
                // These values need to be wiped clean before switching the chart type.
                // But when coming *back* to the previous type we should reload
                previous_values: {
                    group_by_field: null
                },

                data_types: [{
                    value: 'integer',
                    label: 'Integer'
                }, {
                    value: 'year',
                    label: 'Year'
                }],
                agg_functions: [
                    {
                    value: 'sum',
                    label: 'Sum',
                    }, {
                    value: 'count',
                    label: 'Count',
                    }, {
                    value: 'avg',
                    label: 'Average',
                    }, {
                    value: 'min',
                    label: 'Minimum',
                    }, {
                    value: 'max',
                    label: 'Maximum',
                    }, {
                    value: 'distinctcount',
                    label: 'Distinct Count',
                    }, {
                    value: 'avg_zn',
                    label: 'Average, with nulls counted as zeroes'
                  }
                ],

                use_default_data_table:true,
                summary_tables: null,
                show_new_summary_table: false,
                new_summary: {
                    multi_value_field: null,
                    category_field: null,
                    name: '',
                    metric1: ''
                },

                extent_default_flattened_id: null,
                metadata_extended: {
                  other_metadata: {
                    flattened_table_id: null,
                  }
                },
                metadata: null,         // The currently-used metadata for the primary chart pulldowns ("Distribution of", "color", etc)
                summary_metadata: null, // If there's a summary table selected, then the metadata for that
                base_metadata: {     // The base metadata for processed assets for this extent
                    multi: null,
                    categories: null,
                    filtered: null
                }
                // base_metadata has three attributes:
                // * filtered -- this is the list of fields available in the flattened database.
                //               This is the value that the core "metadata" field takes for charting (if charting summary table).
                // * multi -- these are the fields that could have multiple values (used for defining a new summary table)
                // * categories -- these are the fields that are probably categories (used for defining a new summary table)
            }
        },
        watch: {
            $route(to,from) {
                console.log('ROUTE CHANGED')
                console.log(from)
                console.log(to)
                // this.chart_config = to.query
                // this.chart_config = this.$route.query
            },
            detail_fields_structured: {
                handler(newValue,oldValue) {
                  this.temp_config.detail_fields = newValue.join()
                }
            },
            chart_config: {
                handler(newValue,oldValue) {
                  // console.log('pushing route')
                  // this.$router.push({ path: 'assets', query: this.chart_config })
                  if (
                      newValue.id !== oldValue.id &&
                      !this.chart_config.asset_filter_id
                  ) this.reset_filter = true
                    this.redraw_conditionally()
                    if (this.loaded_saved) {
                      this.chart_changed_from_saved = true
                    } else {
                      this.loaded_saved = true
                    }
                    this.show_buttons.switch_orientation = false // Switch orientation stopped working a while ago. Need to fix before putting back in.
                    this.show_buttons.dates = 0
                    this.show_buttons.annotations = 0
                    this.show_buttons.binning = 1
                    this.show_buttons.sort = 1
                    this.show_buttons.targets = 0
                    this.show_buttons.field_name = 1
                    this.button_text.size = 'Size'

                    if (newValue.chart_type === 'pie') {
                        this.show_buttons.group = 0
                        this.show_buttons.size_text = 0
                        this.show_buttons.size = 1
                        this.show_buttons.filter = 1
                        this.show_buttons.size2 = 0
                        this.show_buttons.color = 0
                        this.show_buttons.bars = 1
                        this.button_text.size = 'Size'
                    } else if (newValue.chart_type === 'bar' || newValue.chart_type === 'horizontalbar') {
                        if (!this.show_buttons.group && this.previous_values.group_by_field) {
                            this.chart_config.group_by_field = this.previous_values.group_by_field
                        }
                        this.show_buttons.group = 1
                        this.show_buttons.size_text = 0
                        this.show_buttons.size = 1
                        this.show_buttons.filter = 1
                        this.show_buttons.size2 = 0
                        this.show_buttons.color = 1
                        this.show_buttons.bars = 1
                        this.button_text.size = 'Size'
                    } else if (newValue.chart_type === 'treemap' || newValue.chart_type === 'sunburst') {
                        if (!this.show_buttons.group && this.previous_values.group_by_field) {
                            this.chart_config.group_by_field = this.previous_values.group_by_field
                        }
                        this.show_buttons.size_text = 1
                        this.show_buttons.size = 1
                        this.show_buttons.filter = 1
                        this.show_buttons.size2 = 0
                        this.show_buttons.group = 1
                        this.show_buttons.color = 1
                        this.show_buttons.bars = 1
                        this.button_text.size = 'Size'
                    } else if (newValue.chart_type === 'table_custom') {
                        this.show_buttons.size = 0
                        if (!this.chart_config.color_by_field) {
                            if (this.chart_config.agg_function) {
                                this.chart_config.color_by_field = this.chart_config.agg_function + '(`' + this.chart_config.size_field + '`)'
                                if (!this.chart_config.sort_by_aggregation) {
                                this.chart_config.sort_by_field = this.chart_config.size_field
                                this.chart_config.sort_by_aggregation = this.chart_config.agg_function
                            }
                        } else {
                            this.chart_config.color_by_field = "sum(`count`,'count')"
                                if (!this.chart_config.sort_by_aggregation) {
                                    this.chart_config.sort_by_field = 'count'
                                    this.chart_config.sort_by_aggregation = 'sum'
                                }
                            }
                        }
                        // remove color scheme
                    } else if ((newValue.chart_type === 'tableheatmap') || (newValue.chart_type === 'pervasiveness')) {
                        this.show_buttons.group = 0
                        this.previous_values.group_by_field = this.chart_config.group_by_field
                        this.chart_config.group_by_field = null
                        this.show_buttons.size_text = 0
                        this.show_buttons.size = 1
                        this.show_buttons.filter = 1
                        this.show_buttons.size2 = 0
                        this.show_buttons.color = 2
                        this.show_buttons.bars = 1
                        this.button_text.size = 'Cell Values'
                        if (newValue.chart_type === 'pervasiveness') {
                            this.show_buttons.bars = 0
                            this.show_buttons.size = 0
                        } else {
                          this.show_buttons.annotations = true
                        }
                    } else if (newValue.chart_type === 'scatter') {
                        this.show_buttons.group = 0
                        this.previous_values.group_by_field = this.chart_config.group_by_field
                        this.chart_config.group_by_field = null
                        this.show_buttons.size_text = 0
                        this.show_buttons.size = 2
                        this.show_buttons.filter = 1
                        this.show_buttons.size2 = 2
                        this.show_buttons.color = 1
                        this.show_buttons.bars = 0
                        this.button_text.size = 'X'
                        this.button_text.size2 = 'Y'
                    } else if (newValue.chart_type === 'sankey') {
                        this.show_buttons.group = 2
                        this.show_buttons.size = 1
                        this.show_buttons.filter = 1
                        this.show_buttons.size2 = 0
                        this.show_buttons.color = 0
                    } else if (newValue.chart_type === 'strip_plot') {
                      this.show_buttons.group = 2
                      this.show_buttons.size = 1
                      this.show_buttons.filter = 1
                      this.show_buttons.size2 = 0
                      this.show_buttons.color = 2
                      this.show_buttons.bars = 0
                      this.button_text.size = 'Position'
                    } else if (newValue.chart_type === 'timeseries') {
                      this.show_buttons.dates = 2
                      this.show_buttons.group = 0
                      this.show_buttons.color = 0

                      this.show_buttons.size = 1
                      this.button_text.size = 'Vertical Position'

                      this.show_buttons.bars = 1

                    } else if (newValue.chart_type === 'big_number' || newValue.chart_type === 'proportional_area') {
                      this.show_buttons.field_name = 0
                      this.show_buttons.group = 0
                      this.show_buttons.color = 0
                      this.show_buttons.size = 0
                      this.show_buttons.bars = 0
                      this.show_buttons.binning = 0
                      this.show_buttons.sort = 0
                      this.show_buttons.targets = 2
                      this.show_buttons.size = 1
                      if (newValue.chart_type === 'big_number') {
                        this.button_text.size = 'Number Calculation'
                        this.show_buttons.size2 = 0

                      } else {
                        this.button_text.size = 'Top Semicircle Calculation'
                        this.show_buttons.size2 = 2
                        this.button_text.size2 = 'Bottom Semicircle Calculation'
                      }


                    }
                    if (newValue.summary_table_id) {
                        this.get_summary_table_metadata()
                    }
                    this.get_extended_metadata_as_needed()
                    this.loadFilterName()
                },
                deep: true
            },
            chart_changed_from_saved: function() {
              this.charts = this.charts.map(c => {
                let initial_name = c.display_name
                if (initial_name) {
                  if (initial_name[initial_name.length - 1] === '*') c.display_name = initial_name.slice(0, -1)
                  if (this.chart_changed_from_saved && c.id === this.selected_saved_chart) {
                    c.display_name = c.display_name + '*'
                  }
                }
                return c
              })
              /*
              console.log(this.charts)
              let last_chart_in_list_is_unsaved = this.charts[this.charts.length-1].id === -1
              console.log(last_chart_in_list_is_unsaved)
              if (this.chart_changed_from_saved) {
                console.log('chart list needs to select (unsaved)')
                if (!last_chart_in_list_is_unsaved) {
                  let chart = {}
                  chart.id = -1
                  chart.display_name = '(unsaved)'
                  chart.nice_required_job_name = "temp"
                  if (this.charts) {
                    this.charts.push(chart)
                  } else {
                    console.log('skipping pushing (unsaved) to charts list')
                  }
                }
                this.selected_saved_chart = -1
              } else {
                if (last_chart_in_list_is_unsaved) {
                  this.charts.pop()
                }
              }
               */
            },
            extent_id: function() {
                this.have_data = "untried"
                this.error_msg = ""
                this.error_type = null
                this.reset()
                this.show_chart = true // only show the chart (if it wasn't showing already after we have both changed the extent_id *and* set the endpoint (so there's something for the chart component to show)
                this.get_base_metadata()
                this.get_saved_charts()
                this.get_summary_tables()
                if (this.show_over_time) this.get_versions()
                this.redraw()
                this.get_color_schemes()
                this.getTargets()
            },
            tentative_show_annotations_as_boolean: function() {
                this.chart_config.show_annotations = this.tentative_show_annotations_as_boolean===true ? 1 : 0
            },
            tentative_sort_by_asc_as_boolean: function() {
                this.chart_config.sort_by_asc = this.tentative_sort_by_asc_as_boolean===true ? 1 : 0
            },
            snapshotId: function() {
                this.redraw()
            },
            snapshotIndex: function() {
                this.snapshotId = this.snapshots.all[this.snapshotIndex].job_chain_id
                this.snapshotDate = this.snapshots.all[this.snapshotIndex].created_at_friendly
                this.snapshotDescription = this.snapshots.all[this.snapshotIndex].description

                if (this.snapshotIndex>=this.snapshots.count-1) {
                  this.snapshotLatest = true
                } else {
                  this.snapshotLatest = false
                }
                if (this.snapshotIndex<=0) {
                  this.snapshotEarliest = true
                } else {
                  this.snapshotEarliest = false
                }
            },
            selected_saved_chart: function() {
                this.load_saved_chart()
            },
            use_default_data_table: function() {
                if (this.use_default_data_table) {
                    this.chart_config.summary_table_id = null
                    this.metadata = this.base_metadata.filtered
                }
            },
            have_data: function() {
                if (this.have_data==='yes') this.want_show_import = false
                else if (this.have_data==='no') this.want_show_import = true
            }
        },
        computed: {
            metadata_filtered_by_priority: function() {
                return this.metadata
                // need to circle back to get the below working in production (it works locally)
                if (!this.metadata) return null
                else if (this.show_chart_super_advanced) return this.metadata
                else {
                    return this.metadata.filter(field => {
                        return field.priority
                    })
                }
            },
            tour: function() {
              if (this.have_data==='yes') return "AssetsWithDataTour"
              else if (this.have_data==='no') return "AssetsBlankTour"
            },
            fields: function() {
              let temp=[]
              if (this.chart_config) {
                temp.push(this.chart_config.field_name)
                if (this.chart_config.color_by_field && this.chart_config.color_by_field !== this.chart_config.field_name) {
                  temp.push(this.chart_config.color_by_field)
                }
                if (this.chart_config.size_field) {
                  temp.push(this.chart_config.size_field)
                }
                if (this.chart_config.size_field2) {
                  temp.push(this.chart_config.size_field2)
                }
                if (this.chart_config.detail_fields) {
                  this.chart_config.detail_fields.split(',').forEach(f => {
                    temp.push(f)
                  })
                }
              }
              return temp
            },
            group_by_text: function() {
                if (this.chart_config.chart_type === 'treemap' || this.chart_config.chart_type === 'sunburst' || this.chart_config.chart_type === 'icicle') {
                    return "Level 1"
                } else if((this.chart_config.chart_type==='tableheatmap') || (this.chart_config.chart_type==='pervasiveness')){
                    return ""
                } else if (this.chart_config.chart_type==='sankey') {
                    return "From";
                } else {
                    return "Group"
                }
            },
            distribution_word: function() {
              let chart_type = this.chart_config.chart_type
              if (chart_type === 'treemap' || this.chart_config.chart_type === 'sunburst' || this.chart_config.chart_type === 'icicle') {
                return "Level 2"
              } else if((chart_type==='tableheatmap') || (chart_type==='pervasiveness') || (this.chart_config.chart_type==='table_custom')){
                return "Rows"
              } else if(chart_type==='scatter' || chart_type==='strip_plot') {
                return "Point Label"
              } else if(chart_type==='sankey') {
                return "To"
              } else if (chart_type==='timeseries') {
                return "Lines"
              } else {
                return "Distribution"
              }
            },
            distribution_of_text: function() {
                let chart_type = this.chart_config.chart_type
                if (chart_type === 'treemap' || this.chart_config.chart_type === 'sunburst' || this.chart_config.chart_type === 'icicle') {
                    return "Level 2 ="
                } else if((chart_type==='tableheatmap') || (chart_type==='pervasiveness') || (this.chart_config.chart_type==='table_custom')){
                    return "Rows"
                } else if(chart_type==='scatter' || chart_type==='strip_plot') {
                    return "Point Label"
                } else if(chart_type==='sankey') {
                    return "→ To"
                } else if (chart_type==='timeseries') {
                  return "Lines: "
                } else {
                    return "Distribution Of"
                }
            },
            color_by_text: function() {
                if (this.chart_config.chart_type === 'treemap' || this.chart_config.chart_type === 'sunburst') {
                    return "Level 3"
                } else if((this.chart_config.chart_type==='tableheatmap') || (this.chart_config.chart_type==='pervasiveness') || (this.chart_config.chart_type==='table_custom')){
                    return "Columns"
                } else {
                    return "Color"
                }
            },
            color_scheme_value: function() {
              if (this.chart_config.chart_color_scheme_id) {
                return '=' + this.color_schemes.find((scheme) => scheme.id === this.chart_config.chart_color_scheme_id).name
              } else {
                return ''
              }
            },
            bars_text: function() {
                if (this.chart_config.chart_type === 'treemap') {
                    return "Rectangle Count"
                } else if((this.chart_config.chart_type==='tableheatmap') || (this.chart_config.chart_type==='pervasiveness') || (this.chart_config.chart_type==='table_custom')){
                    return "Row Count"
                } else if (this.chart_config.chart_type==='timeseries') {
                    return "Line Count"
                } else if (this.chart_config.chart_type==='word_cloud') {
                  return "Word Count"
                } else if (this.chart_config.chart_type==='pie') {
                    return "Wedge Count"
                } else {
                    return "Bar Count"
                }
            },
            sizing_text: function() {
                let new_text = ""
                if (this.chart_config.agg_function) new_text += this.chart_config.agg_function + "("
                if (this.chart_config.size_field) new_text += this.chart_config.size_field
                if (this.chart_config.agg_function) new_text += ")"
                return new_text
            },
            sizing_text2: function() {
                let new_text = ""
                if (this.chart_config.agg_function2) new_text += this.chart_config.agg_function2 + "("
                if (this.chart_config.size_field2) new_text += this.chart_config.size_field2
                if (this.chart_config.agg_function2) new_text += ")"
                return new_text
            },
            filter_text: function() {
                if (this.filter_name) {
                    return this.filter_name // fixme
                } else {
                    return ""
                }
            },
            chart_height: function() {
                if (!this.is_full_screen) return 600
                else {
                    return screen.height - 30
                }
            },
            chart_width: function() {
                if (!this.is_full_screen) return 1108
                else {
                    return screen.width - 30
                }
            },
            color_text: function() {
                if (this.chart_config.color_by_field) {
                    return this.chart_config.color_by_field
                } else {
                    return ""
                }
            },
            can_crawl: function() {
                return window.chimera.permissions.includes('CRAWL')
            }
        },
        methods: {
            getTargets() {
              axios.get('/api/targets/' + this.extent_id)
                  .then(response => {
                    this.targets = response.data
                  })
                  .catch(error => {
                    console.log('oops getting targets')
                  })
            },
            toggle_click(field) {
                this.modes_enabled.chart = false
                this.modes_enabled.table = false
                this.modes_enabled.import = false
                if (field === 'chart') {
                  this.modes_enabled.chart = true
                }
                if (field === 'table') {
                  this.modes_enabled.table = true
                }
                if (field === 'import') {
                  this.modes_enabled.import = true
                  this.want_show_import = true
                }
            },
            redo() {
                this.url_to_search = this.url_search_results.redirect_to
                this.searchUrl()
            },
            a() {
              if (this.showSnapshotFeatures) {
                this.showSnapshotFeatures = false
              } else {
                this.showSnapshotFeatures = true
              }
            },
            moveVersionForward() {
              if (this.snapshotIndex<this.snapshots.count) this.snapshotIndex++
            },
            moveVersionBackward() {
              if (!this.timeTraveling && this.snapshots.count >= 2) {
                this.snapshotIndex = this.snapshots.count - 2
                this.timeTraveling = true
              } else if (this.snapshotIndex>0) {
                this.snapshotIndex--
              }
            },
            convertToTimeSeries() {
                this.chart_config.chart_type = 'timeseries'
                this.snapshots = null
            },
            filterEditClose() {
              this.$refs.assetFilterEdit.resetOnClose()
            },
            toggle_chart_advanced() {
                if (this.show_chart_advanced)
                    this.show_chart_advanced = false
                else this.show_chart_advanced = true
            },
            get_extended_metadata_as_needed() {
              let flattened_table_id = this.extent_default_flattened_id
              if (this.chart_config.summary_table_id) {
                flattened_table_id = this.chart_config.summary_table_id
              }
              if (flattened_table_id && this.metadata_extended.flattened_table_id !== flattened_table_id) {
                axios.get('/api/flattened/metadata_extended/' + flattened_table_id)
                    .then(response => {
                      this.metadata_extended = response.data
                      // console.log(this.summary_tables)
                    })
                    .catch(error => {
                      console.log('oops getting extended metadata')
                    })
              }
            },
            get_summary_tables() {
                axios.get('/extents/chartableTables/' + this.extent_id)
                    .then(response => {
                        this.summary_tables = response.data.summary_tables
                        // console.log(this.summary_tables)
                    })
                    .catch(error => {
                        console.log('oops getting summary charts')
                    })
            },
            get_versions() {
              axios.get('/api/flattened/versions/' + this.extent_id + '/1')
                  .then(response => {
                    this.snapshots = response.data
                  })
                  .catch(error => {
                    console.log('oops getting versions')
                  })
            },
            get_saved_charts() {
                axios.get('/api/assets/get_charts_for_extent/' + this.extent_id)
                    .then(response => {
                        this.charts = response.data
                        // console.log(response)
                    })
                    .catch(error => {
                        console.log('oops getting saved charts')
                    })
            },
            show_save_chart_dialog() {
              this.save_chart_show = true
            },
            // This code will be REPEATED in other components that need to load initial
            // values from chart configs (since the components that need this treat these
            // values differently -- for instance, small multiple component will iterate
            // across values to send to SingleFieldBarChart)
            load_saved_chart() {
                if (this.selected_saved_chart != -1) {
                  axios.get('/api/assets/get_chart/' + this.extent_id + '/' + this.selected_saved_chart)
                      .then(response => {
                        this.chart_config = response.data
                        this.chart_changed_from_saved = false
                        this.loaded_saved = false
                        if (this.chart_config.id !== 1) {
                          if (this.chart_config.default_view===2) {
                            this.modes_enabled.chart = false
                            this.modes_enabled.table = true
                          } else {
                            this.modes_enabled.chart = true
                            this.modes_enabled.table = false
                          }
                        }
                        if (this.chart_config.summary_table_id) {
                          this.use_default_data_table = false
                        } else {
                          this.use_default_data_table = true
                        }
                        this.loadFilterName()
                      })
                      .catch(error => {
                        console.log('oops getting saved charts')
                      })
                }
            },
            save_chart(save_as_new=true) {
                let chart_config_id = null
                if (!save_as_new) {
                  chart_config_id = this.chart_config.id
                }
                let saveChartEndPoint = this.addConfig('/api/assets/save_chart_to_extent/' + this.extent_id + '?')
                axios.post(saveChartEndPoint, {
                    id: chart_config_id,
                    field_name: this.chart_config.field_name,
                    description: this.new_chart_description,
                    name: this.new_chart_name,
                    chart_type: this.chart_config.chart_type,
                    group_by_field: this.chart_config.group_by_field,
                    summary_table_id: this.chart_config.summary_table_id,
                    size_field2: this.chart_config.size_field2,
                    agg_function2: this.chart_config.agg_function2,
                    detail_fields: this.chart_config.detail_fields,
                    show_annotations: this.chart_config.show_annotations,
                    all_filter_tests: this.all_filter_tests,
                    default_view: this.modes_enabled.table ? 2 : 1,
                }).then(response => {
                    this.get_saved_charts()
                    this.save_chart_show = false
                }).catch(error => {
                    console.log('oops saving chart')
                    console.log(error.response)
                    this.error(error.response.data,"error")
                    this.save_chart_show = false
                })
            },
            error(msg, severity) { // function to DISPLAY an error in the UI
                this.error_msg = msg
                this.error_type = severity
            },
            updateAllFilterTests(payload) {
              this.reset_filter = false
              console.log('(In AssetsPage updateAllFilterTests) payload: ')
              console.log(payload)
              if (payload.changed) this.chart_changed_from_saved = true
              if (payload.all_filter_tests) {
                // If we are live, dynamically setting filter tests,
                // we don't want to yet change the asset filter as stored
                // in the database -- and we don't want to use the
                // filter as it's stored in the database either.

                this.chart_config.asset_filter_id = null
                this.all_filter_tests = payload.all_filter_tests
                this.temp_filter_tests_to_add = null
                this.redraw_count++
              }
            },
            colorsLoaded(payload) {
              this.colors = payload.colors
            },
            chartMetaLoaded(payload) {
              this.chartMeta = payload.meta
            },
            dataLoaded() {
              this.have_data = 'yes'
            },
            set_drilldown(payload) {
              this.temp_filter_tests_to_add = payload.filter_values
                // If it's not a hierarchy we are drilling down, then we do not want to change anything but the primary field
                if (payload.group_by_field !== false) {
                    this.chart_config.group_by_field = payload.group_by_field
                }
                if (payload.color_by_field) {
                    this.chart_config.color_by_field = payload.color_by_field
                }
                this.chart_config.field_name = payload.primary_field
            },
            chartError(error) { // function to PROCESS an error from children Vue components
                this.show_chart = false
                if (error.error_class==="ERR_NO_DATA") {
                    this.have_data = "no"
                    this.crawl_button_type = "warning"
                    if (this.extent_type !== "Site") {
                        this.can_show_import = false
                        let msg = "This is a " + this.extent_type + ". You do not import or crawl assets at this level, but you do need to PROCESS the children extents first. This is not yet implemented in the web interface."
                        this.error(msg,"warning")
                    } else {
                        console.log("This IS a site")
                        this.error("You need to import assets before exploring via charts.", "warning")
                    }
                } else if (error.error_class==="ERR_CONFIG") {
                    this.error(error.error_message,"error")
                } else if (error.error_class==="ERR_NO_FLATTENED") {
                    this.have_data = "no"
                    let msg = "You need to import data, processing all the way through the optimize step. You can import by crawling or by importing from another source below."
                    this.error(msg,"error")
                } else {
                    this.error(error.error_message,"error")
                }
            },
            handleCheckChangeParent(selected_extent,user) {
                this.user = user
                this.extent_id = selected_extent.id
                this.extent_type = selected_extent.type
                this.extent_state = selected_extent.state
                this.extent_default_chart_config_id = selected_extent.default_chart_config_id
                this.extent_default_flattened_id = selected_extent.default_flattened_id
            },
            startProcessing(selected_extent) {
                axios.post('/api/jobChains', {
                    extent_id: selected_extent.id,
                    type: "flatten"
                }).then(response => {
                    // console.log(response)
//                    window.location.href = '/progress/'
                    // need to come back so that we pass the job chain to progress
                    window.location.href = '/progress/' + response.data.job_chain_id
                }).catch(error => {
                    console.log('oops problem starting processing job')
                    console.log(error.response)
                })
            },
            startProcessingSummary() {
                axios.post('/api/jobChains', {
                    flattened_id: this.chart_config.summary_table_id,
                    type: "flatten"
                }).then(response => {
                    // console.log(response)
//                    window.location.href = '/progress/'
                    // need to come back so that we pass the job chain to progress
                    window.location.href = '/progress/' + response.data.job_chain_id
                }).catch(error => {
                    console.log('oops problem starting processing job')
                    console.log(error.response)
                })
            },
            saveSummaryDefinitionAndFlatten() {
              // Save the Summary Definition
                let extent_id = this.extent_id
                axios.post('/api/flattened/multi/' + extent_id, {
                    multi_field: this.new_summary.multi_value_field,
                    category_field: this.new_summary.category_field,
                    summary_name: this.new_summary.name,
                    metric1: this.new_summary.metric1
                }).then(response => {
                    this.chart_config.summary_table_id = response.data
                    this.startProcessingSummary()
                }).catch(error => {
                    console.log('oops saving the new summary definition and then generating the summary table')
                    console.log(error.response)
                })
              // Save this as the id
              // call startProcessingSummary
            },
            showNewSummaryTable() {
              this.show_new_summary_table = true
            },
            get_summary_table_metadata() {
                axios.get('/api/flattened/metadata/' + this.chart_config.summary_table_id)
                    .then(response => {
                        this.new_summary.metadata = response.data
                        this.metadata = this.new_summary.metadata
                    })
                    .catch(error => {
                        console.log('oops getting summary metadata')
                    })
            },
            get_color_schemes() {
                axios.get('/api/color_schemes/' + this.extent_id)
                    .then(response => {
                      this.color_schemes = response.data
                      // console.log(response)
                    })
                    .catch(error => {
                      console.log('oops getting color schemes')
                    })
            },
            get_base_metadata() {
                axios.get('/api/assets/metadata/' + this.extent_id)
                    .then(response => {
                        this.base_metadata = response.data
                        this.metadata = this.base_metadata.filtered
                        // console.log(response)
                    })
                    .catch(error => {
                        console.log('oops getting base metadata')
                    })
            },
            switch_orientation() {
                if (this.chart_config.chart_type === "bar") { this.chart_config.chartT_type = "horizontalbar"}
                else {this.chart_config.chart_type = "bar"}
                this.chart_changed_from_saved = true

            },
            switch_color_and_primary() {
                let temp = this.chart_config.field_name
                this.chart_config.field_name = this.chart_config.color_by_field
                this.chart_config.color_by_field = temp
                this.chart_changed_from_saved = true

            },
            show_search_url() {
                this.url_show_search = true
            },
            searchUrl() {
                // console.log(this.url_to_search)
                let encoded_url = encodeURIComponent(this.url_to_search)
                // console.log(encoded_url)
                axios.get('/migration/search_url/' + this.extent_id + "?url=" + encoded_url)
                    .then(response => {
                        this.url_search_results = response.data
                        if (this.url_search_results.times_encountered > 0) {
                            this.url_found_result = true
                            this.url_no_results = false
                        } else {
                            this.url_no_results = true
                        }
                        // console.log(response)
                    })
                    .catch(error => {
                        this.url_found_result = false
                        console.log('oops getting search results')
                    })
            },
            go_details(extent_id,asset_id) {
                window.open("/assetdetails/" + extent_id + "/" + asset_id,'_blank')
            },
            go_table_definition() {
              window.open("/flattened/metadata/" + this.metadata_extended.other_metadata.flattened_table_id)
            },
            loadFilterName() {
              if (this.chart_config.asset_filter_id) {
                axios.get('/api/filters/' + this.chart_config.asset_filter_id)
                    .then(response => {
                      this.filter_name = response.data.name
                    })
                    .catch(error => {
                      console.log('oops asset filter')
                    })
              }
            },
            handleFilterLoaded(filter) {
            },
            handleFilterSaved(filter) {
                this.chart_config.asset_filter_id = filter.id
                this.filter_name = filter.name
                this.chart_changed_from_saved = true
                this.filter_show = false
                this.redraw()
            },
            handleFilterReset() {
                this.chart_config.asset_filter_id = null
                this.filter_name = ""
                this.chart_changed_from_saved = true
                this.filter_show = false
            },
            filterOverlay() {
                this.filter_show = true
            },
            textSizeOverlay() {
                this.text_size_show = true
            },
            filterCancel() {
                this.asset_filter_id = null
            },
            summaryCancel() {
                this.show_new_summary_table = false
            },
            initiate_detail_dialog() {
                this.temp_config.detail_fields = this.chart_config.detail_fields
                this.detail_show = true
            },
            save_details_field() {
                this.chart_config.detail_fields = this.temp_config.detail_fields
                this.detail_show = false
            },
            colorOverlay() {
              this.tentative_color_by_field = this.chart_config.color_by_field
              this.color_show = true
            },
            colorSchemeOverlay() {
              this.chart_color_scheme_id = this.chart_config.chart_color_scheme_id
              this.color_scheme_show = true
            },
            colorSet() {
                this.chart_config.color_by_field = this.tentative_color_by_field
                this.chart_config.max_colors = this.tentative_max_colors ? parseInt(this.tentative_max_colors) : null
                this.chart_changed_from_saved = true
                this.color_show = false
            },
            colorSchemeSet() {
              this.chart_config.chart_color_scheme_id = this.tentative_color_scheme
              this.chart_changed_from_saved = true
              this.color_scheme_show = false
            },
            colorCancel() {
                this.chart_config.color_by_field = null
                this.chart_config.chart_color_scheme_id = null
                this.color_show = false
            },
            colorSchemeCancel() {
              this.chart_config.chart_color_scheme_id = null
              this.color_scheme_show = false
          },
            groupOverlay() {
                this.group_show = true
            },
            groupSet() {
                this.chart_config.group_by_field = this.tentative_group_by_field
                this.chart_config.max_groups = this.tentative_max_groups ? parseInt(this.tentative_max_groups) : null
                this.group_show = false
                this.chart_changed_from_saved = true
            },
            groupCancel() {
                this.chart_config.group_by_field = null
                this.group_show = false
            },
            maxBarsOverlay() {
                this.max_bars_show = true
            },
            maxBarsSet() {
                this.chart_config.max_bars = this.tentative_max_bars ? parseInt(this.tentative_max_bars) : null
                this.max_bars_show = false
                this.chart_changed_from_saved = true
            },
            maxBarsCancel() {
                this.chart_config.max_bars = null
                this.max_bars_show = false
            },
            sortOverlay() {
                this.sort_show = true
            },
            sortCancel() {
                this.chart_config.sort_by_field = null
                this.chart_config.sort_by_aggregation = null
                this.chart_config.sort_by_asc = false
                this.tentative_sort_by_field = null
                this.tentative_sort_by_aggregation = null
                this.tentative_sort_by_asc_as_boolean = true
                this.sort_show = false
            },
            sortSet() {
              this.chart_config.sort_by_field = this.tentative_sort_by_field
              this.chart_config.sort_by_aggregation = this.tentative_sort_by_aggregation
              this.sort_show = false
            },
            binOverlay() {
                this.bin_show = true
            },
            binSet() {
              this.chart_config.bin_field = this.tentative_bin_field
              this.chart_config.bin_color = this.tentative_bin_color
              this.bin_show = false
            },
            sizeOverlay() {
                this.size_show = true
            },
            sizeOverlay2() {
                this.size_show2 = true
            },
            sizeSet() {
                this.size_show = false
                this.chart_changed_from_saved = true
            },
            sizeSet2() {
                this.size_show2 = false
                this.chart_changed_from_saved = true
            },
            sizeCancel() {
                this.chart_config.size_field = null
                this.size_show = false
            },
            sizeCancel2() {
                this.chart_config.size_field2 = null
                this.chart_config.size_show2 = false
            },
            redraw(forced) {
                this.forced = forced
                this.redraw_count++
            },
            redraw_conditionally() {
                if (!this.last_redraw) {
                    this.last_redraw = new Date()
                }
                let now = new Date()
                let time_diff = now - this.last_redraw
                let threshold = 1000
                if (this.redraw_count === 0) {
                    threshold = 5000
                }
                if (time_diff > threshold) {
                    this.last_redraw = new Date()
                    this.redraw()
                    // console.log('going to bump version number since time is over threshold')
                }
            },
            // This function is repeated in different components
            addConfig(path) {
                let new_config_params = ""

                for (const [key, value] of Object.entries(this.chart_config)) {
                    if (value) {
                        new_config_params += key + "=" + value + "&"
                    }
                }
                return path + new_config_params + 'sequence_id=' + this.snapshotId
            },
            to_outline() {
                let base = '/api/assets/outline/' + this.extent_id + "/" + this.chart_config.field_name + "?"
                window.open(this.addConfig(base),"_blank")                
            },
            download_csv() {
                let base = '/api/assets/csv/' + this.extent_id + "/" + this.chart_config.field_name + "?"
                let full = this.addConfig(base)
              window.open(full,"_blank")
            },
            full_width() {
              if (this.container_class==='container') {
                this.container_class='container-fluid'
              } else {
                this.container_class='container'
              }
            },
            full_screen() {
                const chart = document.getElementById('primary-chart')
                screenfull.request(chart)
                this.is_full_screen = true
                if (screenfull.enabled) {
                    screenfull.on('change', () => {
                        if (!screenfull.isFullscreen) this.is_full_screen = false
                    });
                }
            },
            profile_chart() {
                this.profile = true
                // insert logic to profile here
                this.profile = false
            },
            reset() {
                this.chart_changed_from_saved = false
                if (this.extent_default_chart_config_id) {
                    this.selected_saved_chart = this.extent_default_chart_config_id
                } else {
                    this.selected_saved_chart = 1
                    // here we need to set the user's default view if a specific chart
                    // has not been selected
                    if (this.user.default_view===2) {
                        this.modes_enabled.table = true
                        this.modes_enabled.chart = false
                    }
                }
                this.load_saved_chart()
            }
        }
    }

</script>
